import React from "react"
import { Link } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import ProductsHero from "../components/products/ProductsHero"
import ProductsContainer from "../components/products/ProductsContainer"
import Product from "../components/products/Product"
import ProductsWrapper from "../components/products/ProductsWrapper";

const ProductsPage = () => (
  <Layout>
    <SEO title="Products" />
    <ProductsHero />
    <ProductsWrapper />
    {/* <Product product={{points: 1}}/> */}
  </Layout>
)

export default ProductsPage
